// Smooth marquee animation for client references
let marqueeAnimation;
let marqueeElements = [];

document.addEventListener("turbo:load", function () {
  // Only initialize if marquee elements exist on the page
  if (!document.querySelector('.client-references-marquee')) return;

  // Initialize marquee for client references
  initMarquee();
});

document.addEventListener("turbo:before-cache", function () {
  // Clean up animation
  if (marqueeAnimation) {
    cancelAnimationFrame(marqueeAnimation);
    marqueeAnimation = null;
  }
  marqueeElements = [];
});

function initMarquee() {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  const marqueeContainers = document.querySelectorAll('.client-references-marquee');

  marqueeContainers.forEach(container => {
    const track = container.querySelector('.client-references-marquee__track');
    if (!track) return;

    let translateX = 0;
    let isPaused = false;
    const speed = 0.5; // pixels per frame (adjust for speed)

    // Get the width of half the content (since we duplicate it)
    const getHalfWidth = () => {
      const items = track.querySelectorAll('.client-references-marquee__item');
      const itemCount = items.length / 2; // We duplicate the items
      let width = 0;

      for (let i = 0; i < itemCount; i++) {
        width += items[i].offsetWidth;
      }

      // Add gaps between items
      const gap = parseFloat(getComputedStyle(track).gap) || 16;
      width += gap * (itemCount - 1);

      return width;
    };

    const animate = () => {
      if (!isPaused) {
        translateX -= speed;
        const halfWidth = getHalfWidth();

        // Reset when we've moved half the content width
        if (Math.abs(translateX) >= halfWidth) {
          translateX = 0;
        }

        track.style.transform = `translate3d(${translateX}px, 0, 0)`;
      }

      marqueeAnimation = requestAnimationFrame(animate);
    };

    // Pause on hover
    // container.addEventListener('mouseenter', () => {
    //   isPaused = true;
    // });

    // container.addEventListener('mouseleave', () => {
    //   isPaused = false;
    // });

    // Start animation
    animate();

    marqueeElements.push({
      container,
      track,
      animate
    });
  });
}
